import { addEventEntry, addDataLayerEntry } from '@printdeal/data-layer-manager';

export const dispatchDataLayerEventOnAccountItemClick = (item: string) => {
  // GA3
  addEventEntry({
    eventCategory: 'account_dashboard',
    eventAction: 'click',
    eventLabel: item,
  });

  // GA4
  addDataLayerEntry('click_account_dashboard_item', {
    linkTo: item,
  });
};
